'use client';

import 'BomdisoftComponents/navigation/nav-dock/styles.css';
import { isNavDockItemActive, type NavDockAppearance, type NavDockItemOptions, toNavDockVariables, toRenderedPath } from 'BomdisoftComponents/navigation/nav-dock/render';
import Link from 'next/link';
import { useParams, usePathname } from 'next/navigation';
import { type CSSProperties } from 'react';

export type { NavDockAppearance } from 'BomdisoftComponents/navigation/nav-dock/render';

export type NavDockItem = NavDockItemOptions & {
  /** View-switch mode: invoked on click when there is no `href`. */
  onSelect?: () => void;
};

export type NavDockProps = {
  items: NavDockItem[];
  testId?: string;
  appearance?: NavDockAppearance;
};

export const NavDock = ({ items, testId = 'nav-dock', appearance }: NavDockProps) => {
  const params = useParams();
  const lang = typeof params.lang === 'string' ? params.lang : undefined;
  const normalizedPath = toRenderedPath(usePathname() ?? '', lang);

  return (
    <nav className='bomdisoft-nav-dock' data-testid={testId} style={toNavDockVariables(appearance) as CSSProperties}>
      {items.map(item => {
        const active = isNavDockItemActive(item, normalizedPath);
        return item.href ? (
          <Link className='bomdisoft-nav-dock-item' data-active={active || undefined} data-testid={item.testId} href={item.href} key={item.testId}>
            {item.label}
          </Link>
        ) : (
          <button className='bomdisoft-nav-dock-item' data-active={active || undefined} data-testid={item.testId} key={item.testId} onClick={item.onSelect} type='button'>
            {item.label}
          </button>
        );
      })}
    </nav>
  );
};
